/*
 ** Hubspot code
 */
export const init = () => {
  const script = document.createElement('script');
  script.id = 'hs-script-loader';
  script.src = 'https://js.hs-scripts.com/6869574.js';
  document.head.appendChild(script);
};
